// import { defineStore } from 'pinia';
// import i18n from '@/locales/i18n'; // ose nga ku ke instaluar i18n
// import getSubdomain from '@/utils/getSubdomain';

// export const useMenuStore = defineStore('menu', {
//   state: () => ({
//     menus: [],
//     subdomain: null,
//   }),
//   actions: {
//     loadMenus() {
//       let subdomain = getSubdomain();
    
//       // Vendos default vetëm nëse subdomain është null dhe nuk është subdomain lokal
//       if (!subdomain && !window.location.hostname.includes('localhost')) {
//         subdomain = 'prokuroria-rks.org';
//       } else if (!subdomain && window.location.hostname === 'localhost') {
//         subdomain = "prokuroria-rks.org";
//       }
//       this.subdomain = subdomain;
//       let locale = i18n.global.locale || i18n.locale || "AL";
//       const localesData = i18n.global.messages[locale];
//       if (localesData?.menus?.[this.subdomain]) {
//         this.menus = localesData.menus[this.subdomain];
//       } else {
//         console.error(`Menuja për ${this.subdomain} dhe gjuhën ${locale} nuk u gjet!`);
//         this.menus = [];
//       }
//     }
//   },
// });
import { defineStore } from 'pinia';
import i18n from '@/locales/i18n'; // ose nga ku ke instaluar i18n
import getSubdomain from '@/utils/getSubdomain';

export const useMenuStore = defineStore('menu', {
  state: () => ({
    menus: [],
    subdomain: null,
  }),
  actions: {
    loadMenus() {
  // merr subdomain (fallback për localhost)
  const sd = getSubdomain();
  const defaultSub = 'prokuroria-rks.org';
  this.subdomain = sd || defaultSub;

  // përcakto locale me fallback "AL"
  let locale = 'AL';
  try {
    const candidate = i18n?.global?.locale ?? i18n?.locale;
    if (candidate) {
      if (typeof candidate === 'object' && 'value' in candidate) {
        locale = candidate.value || locale;
      } else if (typeof candidate === 'string' && candidate.length) {
        locale = candidate;
      }
    } else if (i18n?.global?.fallbackLocale) {
      locale = i18n.global.fallbackLocale;
    } else if (Array.isArray(i18n?.global?.availableLocales) && i18n.global.availableLocales.length) {
      locale = i18n.global.availableLocales[0];
    }
  } catch (e) {
    locale = 'AL';
  }

  // marr mesazhet dhe bëj gjetjen case-insensitive
  const messages = i18n?.global?.messages || {};
  const localeKey =
    Object.keys(messages).find((k) => k.toLowerCase() === String(locale).toLowerCase()) ||
    locale ||
    'AL';
  const localesData = messages[localeKey] || messages[locale] || messages['AL'] || {};

  if (localesData?.menus && localesData.menus[this.subdomain]) {
    this.menus = localesData.menus[this.subdomain];
  } else {
    console.warn(`MenuStore: nuk gjeta menu për subdomain="${this.subdomain}" locale="${locale}". Përdoret menu bosh.`);
    this.menus = [];
  }
}
  },
});
